package ru.villawonka.app.presentation.screens.postCard.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.PostUIModel

sealed class PostCardUIState : UIState {

    data object Loading : PostCardUIState()

    data class Error(val failure: NetworkFailure) : PostCardUIState()

    data class Data(
        val post: PostUIModel,
        val sendMessageButtonVisible: Boolean
    ) : PostCardUIState()
}